$.module('MM.util.flint', function () {
  var ACTIONS = {
    data: 'api/v1/apps',
  };

  var ENV_CONFIG = {
    // 环境配置
    'meme/public': {
      'test,dev,local': 'meme/test-public',
    },
  };

  function _getEnvPath(path) {
    var envConf = ENV_CONFIG[path];

    if (!envConf) return path;

    var resultPath = path;

    _.map(envConf, function (value, key) {
      if (key.indexOf(MM.config.mode) > -1) {
        resultPath = value;
      }
    });

    return resultPath;
  }

  function _get(options) {
    var opt = _.assign(
      {
        path: 'meme',
        field: '',
        error: null,
        callback: null,
      },
      options,
    );

    opt.path = _getEnvPath(opt.path);

    return request.get(
      ACTIONS.data + '/' + opt.path + '/' + opt.field,
      'flint',
      {},
      function (res) {
        MM.core.debug('flint-config ', res.data);
        if (_.isFunction(opt.callback)) {
          opt.callback(res.data || {});
        }
      },
      function (err) {
        MM.core.debug('flint-config error: ', err);
        if (_.isFunction(opt.error)) {
          opt.error(err || {});
        }
      },
    );
  }

  function _getField() {
    var opts = {};
    opts.callback = _.last(arguments);
    switch (arguments.length) {
      case 4:
        opts.path = arguments[0];
        opts.field = arguments[1];
        opts.callback = arguments[2];
        opts.error = arguments[3];
        break;
      case 3:
        opts.path = arguments[0];
        opts.field = arguments[1];
        break;
      case 2:
        opts.field = arguments[0];
        break;
    }

    return _get(opts);
  }

  return {
    get: _get,
    getField: _getField,
  };
});
